import { useQuery } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { PinnedItem } from '@/types/dto/PinnedItem';

const usePinnedItems = (enabled: boolean = true) => {
  const queryKey = ['pinned_items'];

  const queryFn = async () => {
    return getPinnedItems();
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default usePinnedItems;

async function getPinnedItems(): Promise<PinnedItem[]> {
  try {
    const response = await BackendClient.get<BackendSuccessResponse<PinnedItem[]>>('/api/chat/pinned-items');

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while fetching pinned items.');
  }
}
